namespace GeniuzPOS.PosShift {
    export interface PsTaxInvoiceListData extends Serenity.ListRequest {
        Header?: PsTaxInvoiceHdRow[];
        DatetoDate?: string;
        Shop?: string;
        Para?: Administration.CsParaRow;
        URLpic?: string;
        BizName?: string;
        BizAddressLine1?: string;
        BizAddressLine2?: string;
        BizAddressLine3?: string;
        TaxId?: string;
    }
}
